import React, { useState, useMemo, useEffect, forwardRef, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import style from './index.module.less'
import { Form, Input, Button, Space } from "antd";
import ViewFile from "./components/viewFile";
import { updateKnowledgeName } from "@/api/dictionary";
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";

const { TextArea } = Input;

interface KnowledgeItem {
    id: string;
    name: string;
    isHome?: boolean;
    downloadAddress: string | null;
    downloadAddressAll: string | null;
    fileInfoId: string;
}
interface KnowledgeFileProps {
    domainId: string | null;
    currentId: string;
    file: KnowledgeItem;
    version: Object;
    onEdit?: () => void;
    pageType:1|2|3|4
}

export interface KnowledgeFileRef {
    setIsEdit: (value: boolean) => void;
}

const KnowledgeFile = forwardRef<KnowledgeFileRef, KnowledgeFileProps>(({ currentId, domainId, file, version, onEdit,pageType }, ref) => {
    const { t } = useTranslation();
    const [isEdit, setIsEdit] = useState(false);
    const [form] = Form.useForm();
    useImperativeHandle(ref, () => ({
        isEdit,
        setIsEdit,
        handleSave
    }));

    // const getFileData = async () => {
    //     // Implementation
    // };

    // useEffect(() => {
    //     getFileData()
    // }, [currentId]);

    const edit = () => {
        if (onEdit) {
            onEdit();
        }
    };

    const handleCancel = () => {
        setIsEdit(false);
    };

    // 编辑知识库名+说明
    const handleSave = async () => {
        const values = await form.validateFields();
        const params = {
            ...values,
            dictId: currentId,
            domainId,
        };
        await updateKnowledgeName(params);
        setIsEdit(false);

    };

    const initialContent = useMemo(() => {
        return currentId === '-1' ? version?.[0]?.description || '-' : <ViewFile file={file} />;
    }, [currentId, file, version]);

    const validateName = (_: any, value: string) => {
        if (!value) {
            return Promise.reject(new Error(t('ikg.input', { name: t('dict.name') })));
        }
        const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_]+$/;
        if (!regex.test(value)) {
            return Promise.reject(new Error(`${t('knowledge.regName')}`));
        }
        return Promise.resolve();
    };

    return (
        <div className={style.knowledgeContent}>
            <div className={style.knowledgeFile}>
                <span className={style['knowledgeFile-time']}>{t('ikg.updateTime')}:{dayjs(version?.[0]?.updateTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                {(currentId === '-1' && pageType === 3) && <EditOutlined onClick={edit} />}
            </div>
            {/* {isEdit ? (
                <Form
                    form={form}
                    layout="vertical"
                    className={style.editForm}
                >
                    <Form.Item
                        name="desc"
                        rules={[{ validator: validateName, required: true }]}
                    >
                        <TextArea
                            autoSize={{ minRows: 30 }}
                            placeholder="请输入内容"
                        />
                    </Form.Item>
                    <Form.Item className={style.formButton}>
                        <Space>
                            <Button onClick={handleCancel}>
                                取消
                            </Button>
                            <Button type="primary" onClick={handleSave}>
                                保存
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            ) : ( */}
            <div className={style.preview}>
                {initialContent}
            </div>
            {/* )} */}
        </div>
    );
});

export default KnowledgeFile;